import store from "@/store";
import authService from "@/Services/AuthService";
import { can } from "@/plugins/can";
import UsuariosIndexPage from "@/Pages/Usuarios/index.vue";
import NewEditUsuarioPage from "@/Pages/Usuarios/NewEditUsuarioPage.vue";
import listaDeUsuariosParaBloquearLiberar from "@/Pages/Usuarios/listaDeUsuariosParaBloquearLiberar.vue";
import RecursosHumanosStepperPage from "@/recursos-humanos-stepper/RecursosHumanosStepperPage.vue";

const checkAdminOrSuperAdmin = async (to, from, next) => {
  let user = store.getters["Auth/user"];
  if (!user && authService.isLoggedIn()) {
    try {
      await authService.syncUserWithStore();
      user = store.getters["Auth/user"];
    } catch (e) {
      // ignore
    }
  }
  const roleName = user?.roleName;
  if ((roleName === "admin" || roleName === "super-admin") && can(["users.*"])) {
    return next();
  }
  return next({ name: "NaoAutorizado" });
};

const checkUsuariosListAccess = async (to, from, next) => {
  let user = store.getters["Auth/user"];
  if (!user && authService.isLoggedIn()) {
    try {
      await authService.syncUserWithStore();
      user = store.getters["Auth/user"];
    } catch (e) {
      // ignore
    }
  }
  const userRoles = (user?.roles || []).map((r) => r.name);
  if (user?.roleName) userRoles.push(user.roleName);
  const allowedRoles = ["admin", "super-admin", "lider", "TI"];
  if (allowedRoles.some((r) => userRoles.includes(r)) || can(["users.*", "users.listar"])) {
    return next();
  }
  return next({ name: "NaoAutorizado" });
};

export default [
  {
    path: "/usuarios/",
    name: "usuarios",
    component: UsuariosIndexPage,
    beforeEnter: checkUsuariosListAccess,
  },
  {
    path: "/usuarios/create",
    name: "usuarios.create",
    component: NewEditUsuarioPage,
    props: { editing: false },
    beforeEnter: checkAdminOrSuperAdmin,
  },
  {
    path: "/usuarios/edit/:usuario_id",
    name: "usuarios.edit",
    component: NewEditUsuarioPage,
    props: { editing: true },
    beforeEnter: checkAdminOrSuperAdmin,
  },
  {
    path: "/usuarios/listaDeUsuariosParaBloquearLiberar",
    name: "usuarios.listaDeUsuariosParaBloquearLiberar",
    component: listaDeUsuariosParaBloquearLiberar,
    beforeEnter: checkAdminOrSuperAdmin,
  },
  {
    path: "/usuarios/recursosHumanos/:usuario_id",
    name: "usuarios.recursosHumanos",
    component: RecursosHumanosStepperPage,
    beforeEnter: checkUsuariosListAccess,
  },
];
